import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import type { IpeTileData } from '../../../interfaces/Tile.interface';
import { Page, RoutingService } from '../../../services/routing/routing.service';
import { SpawnableTile } from '../spawnable-tile/spawnable-tile.component';
import { TileIpeValueSubComponentComponent } from './tile-ipe-value-sub-component/tile-ipe-value-sub-component';

@Component({
    styleUrls: ['./tile-ipe-value.scss'],
    selector: 'tile-ipe-value',
    templateUrl: 'tile-ipe-value.html',
    imports: [TileIpeValueSubComponentComponent, AsyncPipe]
})
export class TileIpeValueComponent extends SpawnableTile<IpeTileData> {
    private _routingService = inject(RoutingService);

    onEdit(newTileData: IpeTileData) {
        this.edited.next(newTileData);
    }

    onDelete() {
        this.deleted.next();
    }

    navigateToTileHistory() {
        this._routingService.goTo(Page.IPE_HISTORY, {
            buildingId: this.tileData.buildingId,
            tileId: this.tileData.tileId
        });
    }
}
